export const redirectUrl = params => {
  let redirectUrlMine = `${window.location.protocol}//${window.location.host}/will-check/`
  if (process.env.NODE_ENV != 'production') {
    redirectUrlMine = `${process.env.VUE_APP_REDIRECT_URL}/will-check/`
  }
  let url = `https://kyc.qianziworth.cn/api/web/willLogin?appId=${
    params.appId
  }&version=1.0.0&nonce=${params.nonce}&orderNo=${params.serialNo}&faceId=${
    params.faceId
  }&url=${encodeURIComponent(redirectUrlMine)}&from=browser&userId=${
    params.userId
  }&sign=${params.H5Sign}&redirectType=1`
  console.log(url)
  window.location.href = url
}

// 腾讯人像核身
export const redirectUrlHuoTiTencent = params => {
  let redirectUrlMine = `${window.location.protocol}//${window.location.host}/huoti/`
  if (process.env.NODE_ENV != 'production') {
    redirectUrlMine = `${process.env.VUE_APP_REDIRECT_URL}/huoti/`
  }

  let url = `https://kyc.qianziworth.cn/api/web/login?appId=${
    params.webankAppId
  }&version=${params.version}&nonce=${params.nonce}&orderNo=${
    params.queryOrderNo
  }&faceId=${params.faceId}&url=${encodeURIComponent(
    redirectUrlMine
  )}&resultType=1&from=browser&userId=${params.userId}&sign=${
    params.sign
  }&redirectType=1`
  console.log(redirectUrlMine)
  console.log(url)
  window.location.href = url
  // window.location.replace(url)
}
